import type { Accept } from 'react-dropzone'

export const MAX_FEC_IMPORT_FILES = 2
export const MAX_FEC_FILE_SIZE_BYTES = 50 * 1024 * 1024

export const FEC_IMPORT_FILE_ACCEPT: Accept = {
  'text/plain': ['.txt'],
}
